export default "__VITE_ASSET__B5UZ03ng__"